import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import logo from "../assets/logo.png";

const Home = () => {
  return (
    <div className="home">

      {/* LEFT TOP LOGO */}
      <div className="top-left-logo">
        <img src={logo} alt="RC Finder Logo" />
      </div>

      {/* NAVBAR (RIGHT SIDE ONLY) */}
      <nav className="navbar">
        <div className="nav-buttons">
          <Link to="/login" className="btn-outline">Login</Link>
          <Link to="/register" className="btn">Register</Link>
        </div>
      </nav>

      <section className="hero">
        <h1>Vehicle RC PDF in Seconds</h1>
        <p>RC Finder is a fast, secure, and reliable digital platform designed to simplify vehicle and identity verification services. Our system allows users to quickly search and download Vehicle Registration Certificates (RC), Driving License details, and PAN information in just a few clicks. Built for retailers and professionals, RC Finder offers instant results, wallet-based payments, and a user-friendly dashboard for smooth daily operations. With advanced security, accurate data sources, and a premium interface, RC Finder helps you save time and work smarter. Experience hassle-free verification services with complete transparency and trusted performance.</p>
        <Link to="/register" className="btn-big">Become a Member!!</Link>
      </section>

    </div>
  );
};

export default Home;
